import { Component, Vue, Prop } from 'vue-property-decorator'
import { CatalogType } from "@api/enums/CatalogTypes";
import { Tag } from '@api/models/Tag';
import { SelectableTag } from '@api/models/SelectableTag';

import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { QueryOperators } from "@api/enums/QueryOperators";

@Component
class CatalogMixin extends Vue {
    @Prop({required: true}) schemaId: string;
    @Prop({required: false}) itemId: string;

    objectRepository: ObjectRepository = this.$repositories.get(RepositoryFabric.OBJECT);

    tags: SelectableTag[] = [];

    async mounted() {
        await this.getTags();
    }

    get catalogType(): CatalogType {
        const catalogs = this.$store.getters['events/selectedEventViewParam']('catalog');
        if (!catalogs) {
            return CatalogType.General;
        }

        const type = catalogs.filter((item: Record<string, any>) => item.schemaId === this.schemaId)?.[0]?.type?.toLowerCase();
        if (type && Object.values(CatalogType).includes(type)) {
            return type;
        }
        return CatalogType.General;
    }

    get isGeneralCatalog() {
        return this.catalogType === CatalogType.General;
    }
    get tagSchemaId() {
        return this.$store.getters['events/tagsSchemaId'](this.schemaId);
    }

    async getTags() {
        if (!this.tagSchemaId) {
            this.tags = [];
            return;
        }

        try {
            const result = await this.objectRepository.query(this.tagSchemaId, {
                take: -1,
                order: [{ column: "orderIndex", direction: "asc" }],
                where: {
                    groupIds: {
                        $containsAnyOrNullOrEmpty: this.$store.state.session.profile?.groupIds || []
                    },
                    parentId: {
                        [QueryOperators.ne]: null
                    }
                }
            }),
                tags = result as Tag[];

            this.tags = tags.map(tag => {
                return { tag: Object.freeze(tag), isSelected: false };
            });
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
    }


    getTagsByIds(ids: string[] | null) {
        if (!ids) {
            return [];
        }
        return this.tags?.filter(item => ids.indexOf(item.tag.id) >= 0)
            .map(item => Object.assign({}, item, { isSelected: false })) ?? [];
    }

    hasVideo(params: Record<string, any>) {
        return !!params?.youTube?.url || params?.custom?.url;
    }
}

export default CatalogMixin
